module.exports = __webpack_public_path__ + "videos/optimised/08e3d8f4c823129fd1dfdeeb6dd612a1.mp4";